import { Container, Row, Col, Form, Card } from 'react-bootstrap';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Sparkle from '../../../../components/Sparkle/Sparkle';
import { useNavigate } from 'react-router-dom';
import { RiSparklingFill } from '@remixicon/react';
import SpinnerButton from '../../../../components/Button/SpinnerButton';
import { fakeResponse } from '../../../../utils/helpers.js';
import { authFetch } from '../../../../utils/apiClient.js';
import { mockRRP } from '../../../../utils/mockData';
import AccessModal from '../../../../components/Modal/AccessModal.jsx';
import useAccessType from '../../../../hooks/useAccessType.js';
import DemoModal from '../../../../components/Modal/DemoModal.jsx';

function RRPFormScreen() {
    const { t } = useTranslation();
    const [formData, setFormData] = useState({
        companyName: '',
        websiteLink: '',
        withdrawalPeriod: '14',
        refundDelay: '14',
        email: '',
        language: '',
    });
    const [validated, setValidated] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const [modalType, setModalType] = useState(null);
    const { getAccessType, isDemo } = useAccessType(true);
    const [showModal, setShowModal] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    async function generateRRP(rrpData) {
        try {
            const res = await authFetch("/api/terms/generate-rrp", {
                method: "POST",
                body: JSON.stringify(rrpData),
            });

            return await res.json()
        } catch (error) {
            console.error("Error generating refund and return policy:", error);
            return null;
        }
    }

    async function generateFakeRRP() {
        return fakeResponse(mockRRP)
    }

    const handleDemo = async () => {
        setIsLoading(true);
        const data = await generateFakeRRP();
        navigate('/terms/rrp/generated', { state: { rrp: data } });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        e.stopPropagation();

        const form = e.currentTarget;

        if (form.checkValidity() === false) {
            setValidated(true);
            return;
        }

        setValidated(false);

        if (isDemo) {
            setShowModal(true);
            return;
        }
        const accessType = getAccessType();
        if (accessType) {
            setModalType(accessType);
            setShowModal(true);
            return;
        }

        setIsLoading(true);
        const data = await generateRRP(formData);
        navigate('/terms/rrp/generated', { state: { rrp: data } });
    };

    return (
        <>
            {isLoading ? (
                <Sparkle />
            ) : (
                <Container className="py-5">
                    <Row className="mb-5">
                        <Col xs={12} className="text-center">
                            <h2 className="title">{t('rrp.title')}</h2>
                        </Col>
                    </Row>

                    <Card>
                        <Card.Body>
                            <Form noValidate validated={validated} onSubmit={handleSubmit} id="rrpForm">
                                <Row className="mb-4 g-4">
                                    <Col xs={12} md={6}>
                                        <Form.Group controlId="companyName">
                                            <Form.Label>{t('rrp.companyName')} *</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="companyName"
                                                value={formData.companyName}
                                                onChange={handleChange}
                                                required
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {t('rrp.companyNameRequired')}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12} md={6}>
                                        <Form.Group controlId="websiteLink">
                                            <Form.Label>{t('rrp.websiteLink')} *</Form.Label>
                                            <Form.Control
                                                type="url"
                                                name="websiteLink"
                                                value={formData.websiteLink}
                                                onChange={handleChange}
                                                placeholder="https://..."
                                                required
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {t('rrp.urlInvalid')}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row className="mb-4 g-4">
                                    <Col xs={12} md={6}>
                                        <Form.Group controlId="withdrawalPeriod">
                                            <Form.Label>{t('rrp.withdrawalPeriod')} *</Form.Label>
                                            <Form.Select
                                                name="withdrawalPeriod"
                                                value={formData.withdrawalPeriod}
                                                onChange={handleChange}
                                                required
                                            >
                                                <option value="14">14 {t('app.days')}</option>
                                                <option value="30">30 {t('app.days')}</option>
                                                <option value="60">60 {t('app.days')}</option>
                                                <option value="90">90 {t('app.days')}</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12} md={6}>

                                        <Form.Group controlId="refundDelay">
                                            <Form.Label>{t('rrp.refundDelay')} *</Form.Label>
                                            <Form.Control
                                                type="number"
                                                name="refundDelay"
                                                value={formData.refundDelay}
                                                onChange={handleChange}
                                                placeholder="14"
                                                min="1"
                                                required
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {t('rrp.refundDelayRequired')}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row className="mb-4 g-4">
                                    <Col xs={12} md={6}>
                                        <Form.Group controlId="email">
                                            <Form.Label>{t('rrp.email')} *</Form.Label>
                                            <Form.Control
                                                type="email"
                                                name="email"
                                                value={formData.email}
                                                onChange={handleChange}
                                                required
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {t('rrp.emailRequired')}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12} md={6}>

                                        <Form.Group controlId="language">
                                            <Form.Label>{t('app.language')} *</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="language"
                                                value={formData.language}
                                                onChange={handleChange}
                                                placeholder="Français, English, Deutsch..."
                                                required
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {t('rrp.languageRequired')}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12} md={{ span: 6, offset: 6 }}>
                                        <SpinnerButton
                                            type="submit"
                                            className="w-100 bg-pink"
                                            disabled={isLoading}
                                            label={<>
                                                <span className="me-2">{t('app.generate')}</span>
                                                <RiSparklingFill size={20} />
                                            </>}
                                        />
                                    </Col>
                                </Row>
                            </Form>
                        </Card.Body>
                    </Card>

                    <AccessModal
                        show={showModal && !isDemo}
                        setShow={setShowModal}
                        modalType={modalType}
                    />

                    <DemoModal
                        show={showModal && isDemo}
                        setShow={setShowModal}
                        onAction={handleDemo}
                    />
                </Container>
            )}
        </>
    );
}

export default RRPFormScreen;
